<template>
  <div>
    <VehiclesHeader title="Detalle de Vehículo"/>
    <VehiclesForm :vehicle="vehicle" @onUpdate="onUpdate"/>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import VehiclesHeader from '../VehiclesHeader'
import VehiclesForm from '../VehiclesForm'

export default {
  name: 'VehicleDetail',
  components: {
    VehiclesHeader,
    VehiclesForm
  },
  props: {
    vehicleId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      vehicle: {}
    }
  },
  created () {
    this.loadProductData()
  },
  methods: {
    ...mapMutations([
      'toggleVehicleBtnLoading'
    ]),
    ...mapActions([
      'getVehicleDetail',
      'updateVehicleDetail',
      'setAlertData'
    ]),
    loadProductData () {
      this.getVehicleDetail(this.vehicleId)
        .then((res) => {
          if (res.exists) {
            this.vehicle = { ...res.data(), id: res.id }
          } else {
            console.log('[getVehicle]', '404 Not Found', 'Redirecting...')
            // this.$router.push({ name: 'Employees' })
          }
        })
        .catch((err) => {
          console.log('[getVehicle]')
          console.log(err)
        })
    },
    onUpdate (data) {
      this.toggleVehicleBtnLoading(true)
      data.updatedAt = new Date().getTime()
      this.updateVehicleDetail(data)
        .then(() => {
          window.scrollTo(0, 0)
          this.toggleVehicleBtnLoading(false)
          this.setAlertData({
            visible: true,
            msg: 'Vehículo Actualizado 🥳',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleVehicleBtnLoading(false)
          console.log('[updateVehicleDetail]')
          console.log(err)
        })
    }
  }
}
</script>
